export default __webpack_public_path__ + "static/media/icon_check_white.a19a97a2.svg";